module.exports = __webpack_public_path__ + "img/m-agr.eeba8790.webp";